import React, { useState } from 'react';
import { Input, InputType, ButtonColor, SpacerAxis, magma, Spacer } from 'react-magma-dom';
import { ActionButton } from '../../../../basic/ActionButton';
import { verifyFactor, enrollFactor } from '../../../../../api';
import { trackingClient } from '../../../../../ext/tracking';
import { trackErrorEvent } from '../../../../../analytics/errorTypeHelper';

export interface VerifyCodeProps {
  email: string;
  onVerified?: () => void;
  onFailure?: (err: Error) => void;
}

function trackVerifyCodeError(error: Error) {
  trackErrorEvent(error, {
    error_type: 'alternate_email_verify_code_failed',
    error_description: 'Alternate email verification code verification failed.',
    error_location: 'VerifyCode.verifyFactor'
  });
}

function trackResendVerificationCodeError(error: Error) {
  trackErrorEvent(error, {
    error_type: 'alternate_email_resend_verification_code_failed',
    error_description:
      'Alternate email verification code resend failed.',
    error_location: 'VerifyCode.enrollFactor'
  });
}

export const VerifyCode: React.FC<VerifyCodeProps> = props => {
  const [verCode, setVerCode] = useState('');

  const storeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVerCode(event.target.value);
  };

  return (
    <>
      <Input
        type={InputType.text}
        labelText="Verification Code"
        onBlur={() => {
          trackingClient.event.verifyAlternateEmail.changeVerificationCode({
            tags: { name: 'verificationCode' }
          });
        }}
        onChange={storeCode}
      />
      <ActionButton
        onActionChildren="Verifying"
        onAction={() => {
          trackingClient.event.verifyAlternateEmail.verifyButtonClick();
          return verifyFactor(verCode);
        }}
        onSuccess={props.onVerified}
        onFailure={(error: Error) => {
          trackVerifyCodeError(error);
          if (props.onFailure) {
            props.onFailure(error);
          }
        }}
      >
        Verify
      </ActionButton>
      <Spacer axis={SpacerAxis.horizontal} size={magma.spaceScale.spacing03}/>
      <ActionButton
        color={ButtonColor.secondary}
        toastOnSuccess="Code sent!"
        toastOnFailure="Code could not be sent"
        onActionChildren="Resending Verification Code"
        onAction={() => {
          trackingClient.event.verifyAlternateEmail.resendValidationCodeClick();
          return enrollFactor(props.email);
        }}
        onFailure={(error: Error) => {
          trackResendVerificationCodeError(error);
        }}
      >
        Resend Verification Code
      </ActionButton>
    </>
  );
};
